
import ReactMarkdown from 'react-markdown';

export const BasicPage = ({content}) => {

    return (<div className="main__content" style={{marginTop: '1rem'}}>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-10 col-lg-8">
                    <ReactMarkdown>{content.body}</ReactMarkdown>
                </div>
            </div>
        </div>
    </div>)

}

